import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function PainelPlacarEntrada() {
  const navigate = useNavigate();

  const [eventoId, setEventoId] = useState("");
  const [categoria, setCategoria] = useState("");

  function abrirClassificacao() {
    if (!eventoId.trim()) return alert("Digite o eventoId");
    if (!categoria.trim()) return alert("Digite a categoria");

    navigate(
      `/painel/placar/classificacao?eventoId=${encodeURIComponent(
        eventoId.trim()
      )}&categoria=${encodeURIComponent(categoria.trim())}`
    );
  }

  function abrirDisputa() {
    if (!eventoId.trim()) return alert("Digite o eventoId");
    if (!categoria.trim()) return alert("Digite a categoria");

    navigate(
      `/painel/placar/disputa?eventoId=${encodeURIComponent(
        eventoId.trim()
      )}&categoria=${encodeURIComponent(categoria.trim())}`
    );
  }

  return (
    <div style={{ padding: 20, maxWidth: 900, margin: "0 auto", color: "white" }}>
      <h2 style={{ marginBottom: 6, color: "#fdd212" }}>📺 Placar do Telão</h2>
      <p style={{ opacity: 0.85, marginTop: 0 }}>
        Selecione o <b>Evento</b> e a <b>Categoria</b> e abra o placar ao vivo.
      </p>

      <div style={box}>
        <label style={lbl}>EventoId</label>
        <input
          style={inp}
          value={eventoId}
          onChange={(e) => setEventoId(e.target.value)}
          placeholder="ex: 692e032b3e2a76f830748b28"
        />

        <label style={lbl}>Categoria</label>
        <input
          style={inp}
          value={categoria}
          onChange={(e) => setCategoria(e.target.value)}
          placeholder="ex: Aspirante / Profissional"
        />

        <div style={{ display: "flex", gap: 10, marginTop: 14, flexWrap: "wrap" }}>
          <button style={btnPrimary} onClick={abrirClassificacao}>
            ✅ Abrir Classificação (Rodízio)
          </button>

          <button style={btnPrimary} onClick={abrirDisputa}>
            🏆 Abrir Disputa
          </button>
        </div>
      </div>

      <div style={{ marginTop: 10, opacity: 0.7, fontSize: 13 }}>
        * Essa tela é só para escolher e abrir o placar. O placar não tem botões, é 100% visual.
      </div>
    </div>
  );
}

const box = {
  background: "linear-gradient(145deg, #1e1e1e, #2a2a2a)",
  borderRadius: 16,
  padding: 16,
  boxShadow: "0 10px 25px rgba(0,0,0,.25)",
  border: "1px solid rgba(255,255,255,.05)",
};

const lbl = { display: "block", marginTop: 10, marginBottom: 6, fontSize: 13, opacity: 0.9 };

const inp = {
  width: "100%",
  padding: 10,
  borderRadius: 10,
  border: "1px solid rgba(255,255,255,.1)",
  outline: "none",
  background: "rgba(255,255,255,.08)",
  color: "#fff",
};

const btnPrimary = {
  flex: 1,
  minWidth: 260,
  padding: "12px 14px",
  borderRadius: 14,
  border: "none",
  background: "#fdd212",
  color: "#111",
  cursor: "pointer",
  fontWeight: 900,
};
